import React from 'react';

const FormLoader: React.FC = () => {
	return (
		<div className="c-form-skeleton">
			<div className="c-form-skeleton__title"></div>

			<div className="row form-row">
				<div className="col-md-3">
					<div className="a-input-skeleton">
						<div></div>
					</div>
				</div>
			</div>

			<div className="c-form-skeleton__actions">
				<div className="c-form-skeleton__cta"></div>
				<div className="c-form-skeleton__cta"></div>
			</div>
		</div>
	);
};

export default FormLoader;
